const countryAbbreviationMap = {
  Mexico: 'MX',
  China: 'CN',
  Brazil: 'BR',
  Japan: 'JP',
  CostaRica: 'CR',
  Colombia: 'CO',
};
const countryAbbreviationFlipMap = flipKeyVal(countryAbbreviationMap);

function flipKeyVal(obj = {}) {
  let flipObj = {};
  Object.keys(obj).map((key) => {
    flipObj[obj[key]] = key;
  });
  return flipObj;
}

const countryLocaleMap = {
  Mexico: {
    defaultLocale: 'es-MX',
    locales: ['en-US', 'es-MX'],
    theme: 'DiDi',
  },
  China: {
    defaultLocale: 'zh-CN',
    locales: ['zh-CN', 'en-US'],
    theme: 'DiDi',
  },
  Brazil: {
    defaultLocale: 'pt-BR',
    locales: ['en-US', 'pt-BR'],
    theme: '99',
  },
  Japan: {
    defaultLocale: 'ja-JP',
    locales: ['en-US', 'ja-JP'],
    theme: 'DiDi',
  },
  CostaRica: {
    defaultLocale: 'es-CR',
    locales: ['en-US', 'es-CR', 'es-419'],
    theme: 'DiDi',
  },
  Colombia: {
    defaultLocale: 'es-419',
    locales: ['en-US', 'es-419'],
    theme: 'DiDi',
  },
};

export { countryLocaleMap, countryAbbreviationMap, countryAbbreviationFlipMap };
